var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132812 1.93174C0.132812 1.36504 0.628673 0.79834 1.26621 0.79834H30.7345C31.3012 0.79834 31.8679 1.36504 31.8679 1.93174C31.8679 2.56927 31.3012 3.06513 30.7345 3.06513H1.26621C0.628673 3.06513 0.132812 2.56927 0.132812 1.93174ZM0.132812 13.2657C0.132812 12.699 0.628673 12.1323 1.26621 12.1323H30.7345C31.3012 12.1323 31.8679 12.699 31.8679 13.2657C31.8679 13.9032 31.3012 14.3991 30.7345 14.3991H1.26621C0.628673 14.3991 0.132812 13.9032 0.132812 13.2657ZM31.8679 24.5996C31.8679 25.2372 31.3012 25.733 30.7345 25.733H1.26621C0.628673 25.733 0.132812 25.2372 0.132812 24.5996C0.132812 24.0329 0.628673 23.4663 1.26621 23.4663H30.7345C31.3012 23.4663 31.8679 24.0329 31.8679 24.5996Z",
    fill: "#502A7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.773b804178053b2993168fd598ae42fb.svg";
export { ForwardRef as ReactComponent };